// import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

export const cashReceiverService = {
  getCashReceivers: async () => {
    const response = await authInstance
      .get(`${url}/cashReceiverCatalog/list`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createCashReceiver: async (data) => {
    const response = await authInstance
      .post(`${url}/cashReceiverCatalog/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
